import { Box, Container, Link, Typography, IconButton,Divider, Stack} from "@mui/material";
import InstagramIcon from '@mui/icons-material/Instagram';

function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary" sx={{display: "flex", justifyContent: "center",py: 3}}>
        {'© '}
      {new Date().getFullYear()}
    </Typography>
  );
}

export default function Footer() {
  return (
   

    <Container
    component="footer"
    sx={{
    marginTop: 16,
   
  }}
>
  <Box
    sx={{
      position: "relative",
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-around",
      gap: 1,
      width: "100%",
      border: "1px solid",
      borderColor: "divider",
      borderRadius: "10px",
    }}
  >
    <Typography
      align="center"
      sx={{
        position: "absolute",
        top: -10,
        left: "50%",
        transform: "translateX(-50%)",
        backgroundColor: "white",
        padding: "0 10px",
        fontWeight: 200,
        fontSize: 13,
      }}
    >
      Contacts
    </Typography>

    <Box sx={{ display: "flex", alignItems: "center", gap: 1 ,justifyContent: "center"}}>
      <Typography fontSize={13} color="textSecondary">
        Email:
      </Typography>
      <Link fontSize={13} href="mailto:info@ttribbonprint.com">
        info@ttribbonprint.com
      </Link>
      
    </Box>

    <Box sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: "center"}}>
      <Typography fontSize={13} color="textSecondary">
        Social:
      </Typography>
      <IconButton
        color="inherit"
        href="https://www.instagram.com/t_tprint/"
        aria-label="Instagram"
        size="small"
      >
        <InstagramIcon  />
      </IconButton>
     
    </Box>
  </Box>
  <Copyright/>
</Container>

  

 
    
  );
}

